export default __webpack_public_path__ + "static/media/achelam.d0fbcdc1.png";